import Vue from 'vue'
import { mapState } from "vuex";
import { store as headerStore } from '@/code-lab/component/file-management/observable/headerOber.js'
import { store as menueStore } from '@/code-lab/component/layout/control-menue/observable.js'

export default {
    data () {
        return {
            subFolders: [],
            folderList: [],
            previewData: null,
            headerData: [],
            currentWhereFolder: {},
            showPreview: true,
            pageInfo$: { limit: 20, page: 1 },
            scrollLoadState: -1, // 1 加载中 2 max loading data
        }
    },
    created () {
        this.headerData = JSON.parse(JSON.stringify(headerStore[this.currentVersion][this.menueCurrent].headerData))
    },
    methods: {
        updatedPreviewData (data) {
            this.showPreview = false;
            this.previewData = data;
            this.$nextTick(() => {
                this.showPreview = true;
            });
        },
        isNoMoreFile (data) {
            return (data.subFolders && data.subFolders.length) || (data.files && data.files.length)
        },
        handlePreviewData (data) { 
            const { type$ } = data;
            if (type$ === '_id') {
                const id = data[type$]
                const headerItem = { index: this.headerData.length, label: Vue.prototype.$t("code-lab/component/file-management/mixins/mix-table-data-crud.js_0"), query: { folderId: id, path: data.path } }
                this.headerData.push(headerItem)
                Object.assign(this, { folderList: [], subFolders: [], scrollLoadState: -1, pageInfo$: { limit: 20, page: 1 } })
                return this.get_folder_list$(this.responseDataCb, { folderId: id, path: data.path })
            }
        },
        handleHeaderData (data) {
            this.headerData = this.headerData.slice(0, data.index + 1)
            Object.assign(this, { folderList: [], subFolders: [], scrollLoadState: -1, pageInfo$: { limit: 20, page: 1 } })
            return this.get_folder_list$(this.responseDataCb, data.query)
        },
        handleLoadFromScroll () {
            if (this.scrollLoadState > 0) return console.log('scrollLoadState 不允许加载')
            this.scrollLoadState = 1
            const pageObj = { page: this.pageInfo$.page + 1, limit: 20 }
            this.get_folder_list$(response => {
                if (response.status.code == 0) {
                    const scrollLoadResultPayload = response.data.payload[0]
                    const scrollLoadResultPaginationInfo = response.data.query.paginationInfo
                    if (scrollLoadResultPaginationInfo.currentPage <= scrollLoadResultPaginationInfo.totalPages) {
                        Object.assign(this.pageInfo$, pageObj)
                        const { files = []} = scrollLoadResultPayload;
                            files.forEach(file => {
                                file.name$ = file.name;
                                file.type$ = "projectId"
                            })
                        this.folderList = [].concat(this.folderList, files)
                        this.scrollLoadState = -1
                    } else {
                        this.scrollLoadState = 2
                    }
                }
            }, { folderId: this.currentWhereFolder._id, path: this.currentWhereFolder.path, ...pageObj })
        },
        responseDataCb (res) {
            const data = res.data.payload[0] || {}
            
            const { files = [], subFolders = [] } = data;
            files.forEach(file => {
                file.name$ = file.name;
                file.type$ = "projectId"
            })
            subFolders.forEach(folder => {
                folder.name$ = folder.path.split("/").pop()
                folder.type$ = "_id";
            });
            this.folderList = [...subFolders, ...files];
            data.name$ = data.path.split("/").pop()
            data.type$ = "_id";
            this.currentWhereFolder = data;
        },
        
        folderIsFn (o) {
            return o.type$ === '_id' || o._id
        },
        getPathName (pathD, startIndex = 0) {
            const pathNameArr = pathD.slice(-1)[0].query.path.split('/')
            pathD.forEach((item, index) => index > startIndex && (item.label = pathNameArr[index - startIndex]))
        },
    },
    computed: {
        menueCurrent () { return menueStore.current },
        ...mapState(['currentVersion']),
    },
    watch: {
        menueCurrent (newVal) {
            this.headerData = JSON.parse(JSON.stringify(headerStore[this.currentVersion][newVal].headerData))
        },
        headerData (newVal) {
            if (this.currentVersion === 'teacher') {
                return this.getPathName(newVal, 1)
            }
            this.getPathName(newVal, 0)
        },
    },
}
